
// Vue
import { Component, Mixins } from 'vue-mixin-decorator';
// Components
import BaseComponent from './BaseComponent.vue';

/**
 * ローダー表示コンポーネント
 */
@Component
export default class Loader extends Mixins<BaseComponent>(BaseComponent) {}
